import type { SearchEndpointResponse } from '@ps/isp-web-services-types';

import type { SearchResults, SportsMenuState } from './types';

export const initialSearchResults: SearchResults = {
  uniqueEventTypes: [],
  matches: {
    events: [],
    competitions: [],
    runners: [],
    meetings: []
  }
};

export const defaultLinks: SearchEndpointResponse = {
  eventTypes: {},
  eventsAndRunners: [],
  competitionsAndMeetings: []
};

export const defaultState: SportsMenuState = {
  preloaded: false,
  popular: [],
  az: [],
  search: {
    links: defaultLinks,
    selectedEventTypeId: undefined,
    query: '',
    results: initialSearchResults,
    isFetching: false,
    isNewSearchQuery: true,
    previousSearchResults: [],
    showPreviousSearchResults: false
  }
};
